import React, {Component} from 'react';
import {createSelector} from 'reselect';
import './BioHelper.css';
import PositionAligner from '../widgets/PositionAligner';
import {connect} from 'react-redux';
import actions from './profile.actions';
import {uiActions} from '../chrome';
import {matchPath} from 'react-router-dom';
import FancyButton from '../widgets/FancyButton';

const getStepKeys = props =>
	props.profile && (!props.profile.subscriptionLevel || props.profile.subscriptionLevel !== 'none')
		? PROVIDER_STEP_KEYS
		: USER_STEP_KEYS;
export const getSteps = props =>
	props.profile && (!props.profile.subscriptionLevel || props.profile.subscriptionLevel !== 'none')
		? PROVIDER_STEPS
		: USER_STEPS;

class BioHelper extends Component {
	constructor(props) {
		super(props);

		this.skip = e => {
			e.preventDefault();
			e.stopPropagation();
			this.props.skip(this.props.stepKey);
		};

		this.getProgress = createSelector(
			props => props,
			props =>
				getStepKeys(props).reduce((accum, key) => {
					return getSteps(props)[key].completed(props)
						? accum + 1 / getStepKeys(props).length
						: accum;
				}, 0.0)
		);

		this.getIncomplete = createSelector(
			props => props,
			props =>
				getStepKeys(props).filter(
					key =>
						// Considered incomplete if not actually complete AND NOT skipped
						!getSteps(props)[key].completed(props) &&
						(props.profile &&
							(!props.profile.helperSkipped || props.profile.helperSkipped.indexOf(key) < 0))
				)
		);
	}

	componentWillReceiveProps(nextProps) {
		const incompleteKeys = this.getIncomplete(nextProps);
	}

	render() {
		const {stepKey, center = true, screenSize, path} = this.props;
		const step = getSteps(this.props)[stepKey];

		if (!step) return null;

		let isProfile = matchPath(path, {path: '/@:uniqueName'});
		isProfile = isProfile && isProfile.isExact;

		if (!isProfile) return null;

		const progress = this.getProgress(this.props);
		const incompleteKeys = this.getIncomplete(this.props);
		const {label, instructions} = step;

		return (
			<PositionAligner
				className={`BioHelper screenSize-${screenSize}`}
				center={center}
				shown={stepKey === incompleteKeys[0]}
				scrollIn={true}
				scrollTarget={true}>
				<h1>{label}</h1>
				<p>{instructions}</p>
				{/* NOW THAT WE HAVE GUIDED SIGN-UP, DONT NEED TO SHOW PROGRESS HERE */}
				{/* <div className="BioHelper-progress">
					<div className="BioHelper-progress-area">
						<div className="BioHelper-progress-bar">
							<div className="BioHelper-progress-fill" style={{width: (progress * 100) + '%'}}>

							</div>
						</div>
						<span className="BioHelper-progress-value">{Math.round(progress * 100) + '%'} progress</span>
					</div>
				</div> */}
				<div className="BioHelper-actions">
					<FancyButton onMouseDown={this.skip}>Skip</FancyButton>
				</div>
			</PositionAligner>
		);
	}
}

const ConnectedBioHelper = connect(
	({profile, ui, router}) => ({
		profile,
		screenSize: ui.screenSize,
		path: router.location.pathname
	}),
	(dispatch, {subscriptionLevel}) => ({
		skip: key => {
			dispatch(actions.profileHelperSkip(key));

			// NOTE -- disabled now that we have the guided sign-up.
			// if (!subscriptionLevel || subscriptionLevel !== 'none') {
			// 	dispatch(uiActions.uiMessage('NOTE: You will not show in search results until all profile steps are completed.'));
			// }
		},
		clearSkips: () => dispatch(actions.profileHelperClearSkips())
	})
)(BioHelper);

const PROVIDER_STEPS = {
	basic: {
		label: 'Fill out your basic details',
		instructions:
			'Entering your name, profession and category can help others to find you on the site',
		completed: props =>
			props.profile &&
			props.profile.user &&
			props.profile.user.firstname &&
			props.profile.user.lastname &&
			props.profile.profession &&
			props.profile.category
	},
	avatar: {
		label: 'Upload your photo',
		instructions: 'Add a human element to your profile',
		completed: props => props.profile && props.profile.profile && props.profile.profile.avatarImage
	},
	contact: {
		label: 'Add contact details',
		instructions: 'So people can get in touch with you',
		completed: props =>
			props.profile &&
			props.profile.user &&
			props.profile.user.contacts &&
			props.profile.user.contacts.length
	},
	brief: {
		label: 'Add some detail',
		instructions: 'Help people to get to know more about you and the skills and services you offer',
		completed: props =>
			props.profile &&
			props.profile.profile &&
			props.profile.profile.brief &&
			props.profile.profile.about
	},
	images: {
		label: 'Add some photos',
		instructions: 'Spruce up your profile by adding some attractive images',
		completed: props =>
			props.profile &&
			props.profile.profile &&
			props.profile.profile.images &&
			props.profile.profile.images.length
	},
	invite: {
		label: 'Invite others to the platform',
		instructions:
			'By inviting others to the platform, you can help to build support for your profile.',
		completed: props => props.profile && props.profile.user && props.profile.user.openedInvites
	},
	community: {
		label: 'Join a community',
		instructions: 'Build trust for your brand by engaging with the community',
		completed: props =>
			props.profile && props.profile.communities && props.profile.communities.length
	}
};

const USER_STEPS = {
	basic: {
		label: 'Fill out your basic details',
		instructions: 'Entering your name can help others to identify you on the site',
		completed: props =>
			props.profile &&
			props.profile.user &&
			props.profile.user.firstname &&
			props.profile.user.lastname
	},
	invite: {
		label: 'Invite others to the platform',
		instructions:
			'By inviting others to the platform, you help to build the quality and variety of providers listed on the site.',
		completed: props => props.profile && props.profile.user && props.profile.user.openedInvites,
		showOnce: true
	},
	community: {
		label: 'Join a community',
		instructions: 'Build trust for your brand by engaging with the community',
		completed: props =>
			props.profile && props.profile.communities && props.profile.communities.length
	},
	collections: {
		label: 'Add some providers',
		instructions:
			'The "My providers" page shows providers that you have saved. Use search to find providers.',
		completed: props => props.profile && props.profile.favourites && props.profile.favourites.length
	}
};

const PROVIDER_STEP_KEYS = Object.keys(PROVIDER_STEPS);
const USER_STEP_KEYS = Object.keys(USER_STEPS);

export default ConnectedBioHelper;



// WEBPACK FOOTER //
// ./src/profile/BioHelper.js